module.exports = __webpack_public_path__ + "static/media/55.e52697f1.jpg";